import { CircularProgress, Container } from '@mui/material';
import React from 'react';



export const Loading = () => {


  return (
    <Container sx={{margin:"auto", textAlign: "center"}}>
      <CircularProgress color="secondary" size={100}/>
    </Container>
  )
}